import { expedienteServicioService } from "@/_services";
export const expedienteServicio = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    patch: {
      data: {},
      status: {},
    },
    excel: {
      data: {},
      status: {},
    },
    leido: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getExpedientesServiciosRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getExpedientesServiciosSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getExpedientesServiciosError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getExpedienteServicioByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getExpedienteServicioByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getExpedienteServicioByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    putExpedienteRequest(state) {
      state.patch.status = {
        changing: true,
      };
    },
    putExpedienteSuccess(state, response) {
      state.patch.data = response;
      state.patch.status = {
        changed: true,
      };
    },
    putExpedienteError(state, error) {
      state.patch.data = null;
      state.patch.status = {
        error,
      };
    },
    putExpedienteLeidoRequest(state) {
      state.leido.status = {
        changing: true,
      };
    },
    putExpedienteLeidoSuccess(state, response) {
      state.leido.data = response;
      state.leido.status = {
        changed: true,
      };
    },
    putExpedienteLeidoError(state, error) {
      state.leido.data = null;
      state.leido.status = {
        error,
      };
    },
    excelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    excelSuccess(state, pdf) {
      state.excel.data = pdf;
      state.excel.status = {
        downloaded: true,
      };
    },
    excelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
  },
  actions: {
    getExpedientesServicios({ commit }, request) {
      commit("getExpedientesServiciosRequest");
      expedienteServicioService
        .getExpedientesServicios(request.pagination, request.filters)
        .then((response) => {
          commit("getExpedientesServiciosSuccess", response);
        })
        .catch((error) => {
          commit("getExpedientesServiciosError", error);
        });
    },
    getExpedienteServicioById({ commit }, id) {
      commit("getExpedienteServicioByIdRequest");
      expedienteServicioService
        .getExpedienteServicioById(id)
        .then((res) => {
          commit("getExpedienteServicioByIdSuccess", res);
        })
        .catch((error) => {
          commit("getExpedienteServicioByIdError", error);
        });
    },
    putExpediente({ commit }, req) {
      commit("putExpedienteRequest");
      expedienteServicioService
        .putExpediente(req.id, req.body)
        .then((res) => {
          commit("putExpedienteSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteError", error);
        });
    },
    putExpedienteLeido({ commit }, req) {
      commit("putExpedienteLeidoRequest");
      expedienteServicioService
        .putExpediente(req.id, req.body)
        .then((res) => {
          commit("putExpedienteLeidoSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteLeidoError", error);
        });
    },
    getExcel({ commit }, filters) {
      commit("excelRequest");
      expedienteServicioService
        .getExcel(filters)
        .then((excel) => {
          commit("excelSuccess", excel);
        })
        .catch((error) => {
          commit("excelError", error);
        });
    },
  },
};
